import { jsx as _jsx } from "react/jsx-runtime";
export function Avatar({ name, src, size = 'md' }) {
    const initials = name
        .split(/\s+/)
        .slice(0, 2)
        .map((word) => word[0]?.toUpperCase() ?? '')
        .join('');
    return (_jsx("div", { className: "ac-avatar", "data-size": size, "aria-hidden": "true", children: src ? _jsx("img", { src: src, alt: "", loading: "lazy" }) : _jsx("span", { children: initials || '?' }) }));
}
